import type { LibrarySectionConfig } from "../../@types/portalAluno";

export const LIBRARY_SECTIONS: LibrarySectionConfig[] = [
  {
    apiType: "MULTIMIDIA",
    description: "Vídeos, áudios e podcasts para assistir quando quiser.",
    key: "multimidia",
    route: "/app/biblioteca/multimidia",
    sourceType: "biblioteca-multimidia",
    title: "Multimídia",
  },
  {
    apiType: "DOCUMENTOS",
    description:
      "Manuais, guias e materiais de apoio para consultar no dia a dia.",
    key: "documentos",
    route: "/app/biblioteca/documentos",
    sourceType: "biblioteca-documentos",
    title: "Documentos",
  },
  {
    apiType: "GAMES",
    description: "Quizzes e desafios para praticar o que você aprendeu.",
    key: "games",
    route: "/app/biblioteca/games",
    sourceType: "biblioteca-games",
    title: "Simuladores & Games",
  },
];

export const getLibrarySection = (key?: string) =>
  LIBRARY_SECTIONS.find((section) => section.key === key);
